import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("お問い合わせを送信しました。ありがとうございます！");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="legal-page">
      <h1>お問い合わせ</h1>
      <form onSubmit={handleSubmit}>
        <label>お名前</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />

        <label>メールアドレス</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />

        <label>お問い合わせ内容</label>
        <textarea name="message" rows="5" value={formData.message} onChange={handleChange} required />

        <button type="submit">送信</button>
      </form>
    </div>
  );
};

export default Contact;
